import type { StepConfig } from "@portal/components/multiform/types";
import type { AccountCreateFormData } from "../../schema";
import { HistoryStep } from "./HistoryStep";
import { HistorySummary } from "./HistorySummary";

export const historyStepConfig: StepConfig<AccountCreateFormData> = {
	name: "history",
	label: "History",
	fieldPaths: ["account.history"],
	component: HistoryStep,
	summaryComponent: HistorySummary,
};
